import config from '../../../../../common/config';
import { DEFAULT_LOCALE } from '../../../../../common/i18n';
import { styled } from '@mui/system';
import { Link } from '@mui/material';

export function getGameJamLink(submissionId: string) {
  const domain = `${config.domains[DEFAULT_LOCALE].base}${config.domains[DEFAULT_LOCALE].pathname}`;
  return `${domain}/preview/${submissionId}`;
}

export const GameJamLink = styled(Link)(() => ({
  color: '#ff87dc',
  textDecoration: 'underline',
}));
